import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Survives the Payment Hub redirect; guestCustomerDetailsId is required by the guest verify endpoint.
interface GuestBillPaymentState {
	token: string | null;
	guestCustomerDetailsId: string | null;
	amount: number | null;
	paymentMethod: string | null;
}

const initialState: GuestBillPaymentState = {
	token: null,
	guestCustomerDetailsId: null,
	amount: null,
	paymentMethod: null,
};

const guestBillPaymentSlice = createSlice({
	name: "guestBillPayment",
	initialState,
	reducers: {
		setGuestBillPayment: (
			_state,
			action: PayloadAction<{ token: string; guestCustomerDetailsId: string; amount: number; paymentMethod: string }>
		) => {
			return action.payload;
		},

		clearGuestBillPayment: () => {
			return initialState;
		},
	},
});

export const { setGuestBillPayment, clearGuestBillPayment } = guestBillPaymentSlice.actions;

export default guestBillPaymentSlice.reducer;
